import { formatMoney } from "../../utils/format"

// The four money figures the billing console shows for one company. Due,
// Received and Paid out are the inputs; Net is the result, so it sits below a
// divider with more weight. Label left / figure right keeps long amounts
// readable on a narrow phone instead of truncating them in a grid cell.
function Row({ label, value, tone, emphasis = false }) {
  return (
    <div className="flex items-baseline justify-between gap-3 py-0.5">
      <span
        className={`text-[10px] font-semibold uppercase tracking-wide ${
          emphasis ? "text-slate-600" : "text-slate-500"
        }`}
      >
        {label}
      </span>
      <span className={`tabular-nums ${emphasis ? "text-sm font-black" : "text-xs font-bold"} ${tone}`}>
        {formatMoney(value)}
      </span>
    </div>
  )
}

function ProviderMoneySummary({ summary, period, className = "" }) {
  const due = Number(summary?.due || 0)
  const received = Number(summary?.received || 0)
  const paidOut = Number(summary?.paidOut || 0)
  const net = Number(summary?.net ?? received - paidOut)

  return (
    <div className={`rounded-xl border border-slate-100 bg-slate-50/80 px-3 py-2 ${className}`}>
      {period?.year && (
        <div className="mb-1 flex justify-end">
          <span className="rounded bg-white px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-slate-500 ring-1 ring-slate-200">
            {period.year} YTD
          </span>
        </div>
      )}
      <Row label="Due" value={due} tone={due > 0 ? "text-rose-600" : "text-slate-500"} />
      <Row label="Received" value={received} tone={received > 0 ? "text-emerald-700" : "text-slate-500"} />
      <Row label="Paid out" value={paidOut} tone={paidOut > 0 ? "text-amber-700" : "text-slate-500"} />
      <div className="mt-1.5 border-t border-slate-200 pt-1.5">
        <Row
          label="Net"
          value={net}
          emphasis
          tone={net < 0 ? "text-rose-600" : net > 0 ? "text-emerald-700" : "text-slate-600"}
        />
      </div>
    </div>
  )
}

export default ProviderMoneySummary
